<script setup lang="ts">
// Vue, Vue Router, Pinia
import { ref } from 'vue'
import { useRoute } from 'vue-router'

// Stores

// Components

// Types
// @TODO : Move to a global types file
type Breadcrumb = {
  name: string
  link: boolean
  title: string
  icon: string
}

/*
 *
 *  SERVICES
 *
 * */
const route = useRoute()

// Data, refs
const Header = ref<HTMLElement | null>(null)

// Props
defineProps<{
  title?: string
  subtitle?: string
  breadcrumbs?: Breadcrumb[]
  displayBreadcrumbs: boolean
  hasWidget?: boolean
}>()

// Methods
</script>

<template>
  <div class="col-span-12 grid grid-cols-12 gap-4 p-8" ref="Header">
    <div class="col-span-12 flex-1 md:col-span-8">
      <!--  Breadcrumbs -->
      <div class="col-span-12 flex items-center justify-start gap-2" v-if="displayBreadcrumbs">
        <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
          <component
            :is="breadcrumb.link ? 'router-link' : 'p'"
            :to="{ name: breadcrumb.name }"
            :class="[breadcrumb.link ? 'text-surface-500' : 'text-surface-900']"
            class="max-w-60 overflow-hidden text-ellipsis whitespace-nowrap no-underline"
            :title="breadcrumb.title"
          >
            <i :class="breadcrumb.icon" />
            {{ breadcrumb.title }}
          </component>
        </template>
      </div>

      <slot name="breadcrumbs" />

      <h2 class="col-span-12 text-left font-[barlow] text-2xl font-bold uppercase">
        <template v-if="title">{{ title }}</template>
        <slot name="title" />
      </h2>

      <h4 v-if="subtitle" class="medium self-start py-1 font-[barlow] text-xl uppercase">
        {{ subtitle }}
      </h4>
    </div>

    <div class="col-span-12 justify-self-end-safe md:col-span-4" v-if="hasWidget">
      <slot name="widgets" />
    </div>
  </div>
</template>
